import {baseURL} from '.';
import {get} from './common';

export const loadComics = async locale => {
    // eslint-disable-next-line max-len
    let query = `{comics(language: ${locale.toUpperCase()}) { id show title subtitle about baseUrl friendlyName logo cover characters englishTitle chapters { id number cover releaseDate folder images }}}`;

    let result = await get(`${baseURL}?query=${encodeURI(query)}`);

    if (result.data.comics) {
        return result.data.comics;
    }
    throw new Error('Comic list load failed');
};
